import { Injectable } from '@angular/core';
import { BaseService } from '../../../core/service/base-service';
import { HttpClient } from '@angular/common/http';
import { AuthUtilsService } from '../../../core/util/auth-utils.service';
import { PaginationData } from '../../../core/modal/pagination-data';
import { OrderingData } from '../../../core/modal/ordering-data';
import { Observable } from 'rxjs';
import { ResponseData } from '../../../core/modal/base-save-update-response';
import { environment } from '../../../../environments/environment';
import { SystemConfigSettingModel } from '../../../shared/model/system-config-setting-model';
import { SystemConfigService } from '../../../system-config/service/system-config.service';
import { SearchData } from '../../../core/modal/search-data';
import { saveAs } from 'file-saver';
import { VendorModal } from '../modal/vendor-Modal';
@Injectable({
  providedIn: 'root',
})
export class VendorService extends BaseService<VendorModal> {
  systemParam: SystemConfigSettingModel = new SystemConfigSettingModel(this.systemConfigService);
  pagination: { pageIndex: number; perPage: number };
  serverFilterObj: SearchData[] = [];
  constructor(http: HttpClient, private systemConfigService: SystemConfigService, authService: AuthUtilsService) {
    super(http, authService);
  }

  getModuleName(): string {
    return 'party';
  }

  validate(): boolean {
    return false;
  }

  getAll(paginationData: PaginationData, orderingData: OrderingData): Observable<ResponseData<VendorModal>> {
    if (this.systemParam.isPartLedger) {
      return this.http.get<ResponseData<VendorModal>>(environment.SERVER_URL + 'party/getByStaff');
    }
    return super.getAll(paginationData, orderingData);
  }

  getAllByPagination(params): Observable<ResponseData<VendorModal>> {
    return this.http.post<ResponseData<VendorModal>>(environment.SERVER_URL + 'party/getAllByPartner', params);
  }

  getServerFilterObj() {
    return this.serverFilterObj;
  }

  getPartyPrintPdf() {
    var fileName = 'Business Partner PDF';
    var mediaType = 'application/pdf';
    let url = environment.SERVER_URL + this.getModuleName() + '/export/pdf';
    this.http.get(url, { responseType: 'blob' }).subscribe((response) => {
      var blob = new Blob([response], { type: mediaType });
      saveAs(blob, fileName + '.pdf');
    });
  }

  getPartyPrintExcel() {
    var fileName = 'Business Partner EXCEL';
    var mediaType = 'application/excel';
    let url = environment.SERVER_URL + this.getModuleName() + '/export/excel';
    this.http.get(url, { responseType: 'blob' }).subscribe((response) => {
      var blob = new Blob([response], { type: mediaType });
      saveAs(blob, fileName + '.xls');
    });
  }

  setServerFilterObj(filters: SearchData[]) {
    let filterObj = JSON.parse(JSON.stringify(filters));

    if (filterObj && filterObj.length > 0) {
      if (this.serverFilterObj && this.serverFilterObj.length > 0)
        filterObj.map((fObj) => {
          let objIndex = this.serverFilterObj.findIndex(function (obj) {
            return obj.filterColumn == fObj.filterColumn;
          });
          if (objIndex != -1) {
            this.serverFilterObj[objIndex] = fObj;
          } else {
            this.serverFilterObj.push(fObj);
          }
        });
      else {
        this.serverFilterObj = filterObj;
      }
    } else {
      if (this.serverFilterObj && this.serverFilterObj.length > 0) {
        let serverFilterObj = JSON.parse(JSON.stringify(this.serverFilterObj));
        serverFilterObj = this.serverFilterObj.filter((fObj) => {
          return fObj.filterColumn == 'any';
        });
        this.serverFilterObj = serverFilterObj;
      }
    }
    return this.serverFilterObj;
  }

  save(modal: VendorModal): Observable<ResponseData<VendorModal>> {
    return this.http.post<ResponseData<VendorModal>>(environment.SERVER_URL + 'party/registerParty', modal);
  }
}
